import React from 'lib/react';
import {
  EVGrid, EVChip, makeStyles, EVTypography, EVKeyboardArrowDown,
} from 'lib/components';
import { useTranslation } from 'lib/translation';
import { MAX_SELECTED_OPTIONS_LENGTH, MIN_SELECTED_OPTIONS_LENGTH } from 'features/orderHistory/OrderHistory.constants';
import PropTypes, { arrayOf, number, oneOfType } from 'prop-types';
import { isEqual } from 'lodash';
import ClearButton from '../clearButton';

const useStyles = makeStyles((theme) => ({
  chipElement: {
    height: '20px',
    textTransform: 'uppercase',
    fontWeight: 700,
    fontSize: '12px',
    margin: '2px',
    maxWidth: '100%',
    '@media (min-width: 640px)': {
      maxWidth: '180px',
    },
  },
  selectedValuesContainer: {
    display: 'flex',
    gap: '2px',
    flexWrap: 'wrap',
    flexDirection: 'column',
    width: '100%',
    '@media (min-width: 1024px)': {
      alignItems: 'center',
      flexDirection: 'row',
      flexWrap: 'nowrap',
    },
  },
  chipsContainer: {
    display: 'flex',
    gap: '2px',
    flexWrap: 'wrap',
    width: '100%',
    '@media (min-width: 1024px)': {
      flexWrap: 'nowrap',
      width: 'min-content',
    },
  },
  filterNameContainer: {
    display: 'flex',
    gap: '2px',
    width: 'auto',
    justifyContent: 'space-between',
    '@media (min-width: 640px)': {
      flexWrap: 'nowrap',
    },
  },
  moreText: {
    alignSelf: 'center',
    color: theme.evPalette.charcoal[800],
    textTransform: 'uppercase',
    fontWeight: 700,
    fontSize: '12px',
  },
}));

function SelectedFiltersRenderValue({
  selectedOptions, optionsList, handleClear, filterName, filterId, iconElement,
}) {
  const classes = useStyles();
  const { t } = useTranslation();
  return (
    <EVGrid className={classes.selectedValuesContainer}>
      <EVGrid className={classes.filterNameContainer}>
        <EVTypography>{filterName}</EVTypography>
        {iconElement}
      </EVGrid>
      <EVGrid className={classes.chipsContainer}>
        {selectedOptions?.slice(0, MAX_SELECTED_OPTIONS_LENGTH)?.map((selectedOptionId) => {
          const selectedOption = optionsList.find((item) => (isEqual(item?.id, selectedOptionId)));
          return (
            <EVChip
              className={classes.chipElement}
              style={{ backgroundColor: selectedOption?.backgroundColor || '#C8CDD7', color: selectedOption?.color || '#4D5365' }}
              key={selectedOption?.id}
              label={selectedOption?.name}
            />
          );
        })}
        {selectedOptions?.length > MAX_SELECTED_OPTIONS_LENGTH
         && <EVTypography className={classes.moreText}>{t('order_history_filter__more')}</EVTypography>}
      </EVGrid>
      {selectedOptions?.length > MIN_SELECTED_OPTIONS_LENGTH && (
        <ClearButton
          id={`clear-${filterId}-button`}
          handleClear={handleClear}
        />
      )}
    </EVGrid>
  );
}
SelectedFiltersRenderValue.defaultProps = {
  iconElement: <EVKeyboardArrowDown />,
};
SelectedFiltersRenderValue.propTypes = {
  selectedOptions: PropTypes.arrayOf(oneOfType([arrayOf(number), number])).isRequired,
  optionsList: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  handleClear: PropTypes.func.isRequired,
  filterName: PropTypes.string.isRequired,
  filterId: PropTypes.string.isRequired,
  iconElement: PropTypes.shape(),
};

export default SelectedFiltersRenderValue;
